import { Button, FormControlSizes, HStack, IconName, useCurrentWindow } from '@talos/kyoko';
import { useNavigate } from 'react-router-dom';
import { AdminPaths } from '../NavigationSidebar/hooks/getNavPath';
import { useMarketSelectorContext } from './MarketSelectorContext';
import { MarketSelectorSettingsButton } from './MarketSelectorSettingsButton';
import { MARKET_SELECTOR_POPOUT_WINDOW_NAME } from './tokens';

export function MarketSelectorPanelHeaderSuffix() {
  const navigate = useNavigate();
  const { isNarrow, disableAggregations } = useMarketSelectorContext();
  const currentWindow = useCurrentWindow();
  const isPopout = currentWindow.name === MARKET_SELECTOR_POPOUT_WINDOW_NAME;

  return (
    <HStack gap="spacing8">
      <HStack gap="spacing4">
        {(!isNarrow || isPopout) && !disableAggregations && (
          <Button
            startIcon={IconName.Exit}
            size={FormControlSizes.Small}
            onClick={() => navigate(AdminPaths.TradingAggregations())}
          >
            Manage
          </Button>
        )}
        <MarketSelectorSettingsButton />
      </HStack>
    </HStack>
  );
}
